import {
  estimateFormDataSize,
  splitFormData,
} from "@/package/global-use-case/useChunks";
import { API } from "../boot/api";

const state = {
  windowInnerWidth: window.innerWidth,
  isShowSidebar: true,
  isCollapsedSidebar: false,
};

const getters = {};

const mutations = {
  SET_INNER_WIDTH(state, width) {
    state.windowInnerWidth = width;
  },

  SET_IS_SHOW_SIDEBAR(state, value) {
    state.isShowSidebar = value;
  },

  SET_IS_COLLAPSED_SIDEBAR(state, value) {
    state.isCollapsedSidebar = value;
  },
};

const actions = {
  uploadingInImagesBuffer(_, file) {
    return new Promise((resolve, reject) => {
      API.post("images", file, {
        headers: { "Content-Type": "multipart/form-data" },
        skipGlobalErrorHandling: true,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async sendImagesToBuffer({ dispatch }, formData) {
    const MAX_BUFFER_SIZE_BYTES = 15 * 1024 * 1024;

    const formDataSize = estimateFormDataSize(formData);

    if (formDataSize > MAX_BUFFER_SIZE_BYTES) {
      const chunks = splitFormData(formData, MAX_BUFFER_SIZE_BYTES);
      const serverResponses = await Promise.all(
        chunks.map((chunk) => dispatch("uploadingInImagesBuffer", chunk))
      );

      return serverResponses.reduce(
        (accum, current) => [...accum, ...current.data.data],
        []
      );
    } else {
      const serverResponse = await dispatch(
        "uploadingInImagesBuffer",
        formData
      );
      return serverResponse.data.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
